import _ from 'lodash';
import { VIEWS } from "@/common/constants";
import { pageConfig } from "@/common/service/page-config";
import store from '@/store/index';
import { updatePlansCheckout, UpdateTypes } from '@/common/service/checkout-utils';
import { getBasePlansFrom } from '@/common/product';
import { planTypes } from "@/common/constants";
import { showCouponTermsMessage } from '@/views/config/coupon/helper/utils';
import { preCheckPendingCouponForEdit } from '@/common/service/validate/coupon';
import { reactiveBizPlanIfCancelled } from '@/plans/ZOOM_MEETING/common/utils';
import { checkPlanDownSellForEdit } from '@/common/service/validate/downsell';
import { DowngradeFlow } from './helper';

const loadDefaultSelectByQueryForBiz2Pro = (boughtPlans = []) => {
  return (planList = []) => {
    const { category: targetCategory, planType } = pageConfig?.editConfig || {};
    const hasSelected = planList?.find((p) => p.cartInfo.selected_number > 0);
    if (!hasSelected) {
      const boughtBasePlan = boughtPlans?.find((p) => p.type === planType);
      let { billing_cycle } = boughtBasePlan || {};

      return planList.map((plan) => {
        const isMatchTargetPlan = plan.category === targetCategory && plan.billing_cycle === billing_cycle;
        return isMatchTargetPlan
          ? {
              ...plan,
              cartInfo: {
                ...plan.cartInfo,
                selected_number: boughtBasePlan?.cartInfo.selected_number || 1,
              },
            }
          : plan;
      });
    }
    return planList;
  };
};

const checkPlanDownSellForBiz2Pro = async () => {
  const { getSelectedPlans } = store.getters
  if (!_.some(getSelectedPlans, (plan) => plan.type === planTypes.LARGE_MEETING)) {
    await checkPlanDownSellForEdit()
  }
}

const getDowngradePlanList = () => {
  const getters = store.getters;
  const { planType } = pageConfig.editConfig;
  const currentSelectedPlan = getters.getSelectedPlans.find(item => item.type === planType);
  const boughtPlans = getters.boughtPlans;
  const boughtBasePlan = getBasePlansFrom(boughtPlans)?.[0] || {};
  return [{
    quantity: currentSelectedPlan.cartInfo.selected_number,
    planCode: currentSelectedPlan.plan_code,
    oldPlanCode: boughtBasePlan.plan_code,
  }];
}

const submitForBiz2Pro = async (submitParams) => {
  const planList = getDowngradePlanList()
  const { boughtPlans, getSelectedPlans } = store.getters
  await reactiveBizPlanIfCancelled()
  let updateType = UpdateTypes.BIZ_TO_PRO
  if (!_.some(boughtPlans, (plan) => plan.type === planTypes.LARGE_MEETING)) {
    for (const plan of getSelectedPlans) {
      if (plan.type === planTypes.LARGE_MEETING) {
        updateType = UpdateTypes.SWITCH
        planList.push({
          planCode: plan.plan_code,
          quantity: plan.cartInfo.selected_number
        })
      }
    }
  }
  return updatePlansCheckout(submitParams, planList, updateType)
}

const preCheckForBiz2Pro = async () => {
  await preCheckPendingCouponForEdit()
  await checkPlanDownSellForBiz2Pro()
  await showCouponTermsMessage(store.getters.tncMessage, store.getters);
}

export default class Biz2ProFlow extends DowngradeFlow {
  view() { return VIEWS.COMPOUND }
  init_shopping_cart__hook(res) {
    this.loader.push('loadDefaultSelectByQuery', loadDefaultSelectByQueryForBiz2Pro(res.boughtPlans));
  }
  async init(...params) {
    const result = await super.init(...params)
    // This line is used to set currentEditPlan in shopping-cart store
    pageConfig.oldPlanCode = this.source_plans(result.boughtPlans)[0]?.plan_code;
    return result
  }
  beforeSubmit() { return preCheckForBiz2Pro() }
  submit(submitParams) { return submitForBiz2Pro(submitParams) }
}
